import React from 'react';
import './Navbar.css';
import { NavLink, Link } from 'react-router-dom';

export default function Navbar() {
    return (
        <nav className="nav">
            <div className="nav__inner">
                <Link to="/" className="nav__brand" aria-label="IIT Delhi Timetable, home">
                    <span className="nav__mark" aria-hidden="true" />
                    <span className="nav__wordmark">
                        <span className="nav__wordmark-serif">Timetable</span>
                        <span className="nav__wordmark-mono">/iitd</span>
                    </span>
                </Link>

                <div className="nav__links">
                    <NavLink to="/" end className={({ isActive }) => 'nav__link' + (isActive ? ' is-active' : '')}>
                        Plan
                    </NavLink>
                    <NavLink to="/course-explorer" className={({ isActive }) => 'nav__link' + (isActive ? ' is-active' : '')}>
                        Courses
                    </NavLink>
                    <NavLink to="/empty-halls" className={({ isActive }) => 'nav__link' + (isActive ? ' is-active' : '')}>
                        Empty halls
                    </NavLink>
                </div>
            </div>
        </nav>
    );
}
